import { Button } from "../../../../components/ui/common/button";
import { formatPercentage } from "../utils/recipeAddIngredient.utils";

interface AddIngredientFooterProps {
  remaining: number;
  savedTotal: number;
  hasSaved: boolean;
  hasPending: boolean;
  onClose: () => void;
}

const AddIngredientFooter = ({
  remaining,
  savedTotal,
  hasSaved,
  hasPending,
  onClose
}: AddIngredientFooterProps) => {
  const isDoneDisabled = hasSaved && hasPending;

  return (
    <div className="tw-px-6 tw-py-4 tw-border-t tw-border-border tw-shrink-0 tw-bg-secondary/50 tw-flex tw-items-center tw-justify-between tw-gap-2">
      <div className="tw-text-sm tw-text-muted-foreground">
        Remaining:{" "}
        <span className="tw-font-semibold tw-text-primary">{formatPercentage(remaining)}%</span>
        {savedTotal > 0 ? (
          <>
            {" "}
            · Saved:{" "}
            <span className="tw-font-semibold tw-text-primary">{formatPercentage(savedTotal)}%</span>
          </>
        ) : null}
      </div>
      <Button
        type="button"
        variant="outline"
        onClick={onClose}
        disabled={isDoneDisabled}
      >
        {hasSaved ? "Done" : "Cancel"}
      </Button>
    </div>
  );
};

export default AddIngredientFooter;
